module.exports = __webpack_public_path__ + "img/logo.5d59506e.png";